import { Space, Tag } from "antd"
import { FC } from "react"
import { COLORS_BY_TAG } from "../constants/placements.constants"
import { campaignTagsEnum } from "../types/placement"

interface ICampaignTagsProps {
  campaignTags: campaignTagsEnum[]
}

const CampaignTags: FC<ICampaignTagsProps> = ({ campaignTags }) => {
  return (
    <Space>
      {campaignTags &&
        campaignTags.map((campaignTag) => (
          <Tag key={campaignTag} color={COLORS_BY_TAG[campaignTag]}>
            {campaignTag}
          </Tag>
        ))}
    </Space>
  )
}

export default CampaignTags
